// Add your custom JS here.

// Homepage slider
var swiper = new Swiper(".mySwiper", {
  effect: "fade",
  loop: true,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper-pagination",
  },
});

// Download quick search

const search = () => {
  const searchInput = document.getElementById("search-input").value;
  const downloadGrab = document.querySelectorAll(".data");
  [...downloadGrab].forEach((item) => {
    if (
      item
        .getAttribute("data-title")
        .toLowerCase()
        .includes(searchInput.toLowerCase())
    ) {
      item.classList.remove("d-none");
    } else {
      item.classList.add("d-none");
    }
  });
};

if (document.getElementById("search-input")) {
  document
    .getElementById("search-input")
    .addEventListener("keyup", function () {
      search();
    });
}

// Contact form page
const classRemove = (className, classToRemove) => {
  const classHooks = document.getElementsByClassName(className);
  [...classHooks].forEach((classHook) => {
    classHook.classList.remove(classToRemove);
  });
};

const contactBtnSetUp = (className) => {
  const centerBtns = document.getElementsByClassName(className);
  [...centerBtns].forEach((btn) => {
    btn.addEventListener("click", function (e) {
      if (btn.classList.contains("active")) {
        return;
      } else {
        classRemove("btn-contact", "active");
        classRemove("contact-page", "active");
        btn.classList.add("active");
        let btnId = btn.getAttribute("href").replace("#", "");
        document.getElementById(btnId).classList.add("active");
      }
    });
  });
};

contactBtnSetUp("btn-contact");

const gallerySwiper = document.getElementsByClassName("gallery-Swiper");
[...gallerySwiper].forEach((gallery, index) => {
  gallery.classList.add(`swiper-${index}`);
  console.log(gallery);
  new Swiper(`.swiper-${index}`, {
    slidesPerView: "auto",
    spaceBetween: 10,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
});

// Pick Category

const catPicker = document.getElementById("catergory-picker");
const catList = document.getElementById("cat-list");

if (catPicker != null) {
  catPicker.addEventListener("click", () => {
    catList.classList.toggle("active");
    catPicker.classList.toggle("active");
    console.log("toggle");
  });
}

// table construct

document.addEventListener("DOMContentLoaded", function () {
  //fade in back to top button

  // keep track of previous scroll position
  let prevScrollPos = window.scrollY;

  window.addEventListener("scroll", function () {
    const currentScrollPos = window.scrollY;

    if (currentScrollPos > 800) {
      document.querySelector(".back-to-top-btn").classList.add("active");
    } else {
      document.querySelector(".back-to-top-btn").classList.remove("active");
    }

    // update previous scroll position
    prevScrollPos = currentScrollPos;
  });

  //search bar toggle
  document.getElementById("search-btn").addEventListener("click", () => {
    document.getElementById("search-bar").classList.toggle("active");
    document.getElementById("search-btn").classList.toggle("active");
  });

  document.getElementById("search-btn-mobile").addEventListener("click", () => {
    document.getElementById("search-bar").classList.toggle("active");
    document.getElementById("search-btn-mobile").classList.toggle("active");
  });

  //Link maker elements
  const makeLinksIntoButtons = () => {
    const buttons = document.querySelectorAll(".link-maker a");
    const brElements = document.querySelectorAll(".link-maker br");
    [...buttons].forEach((button) => {
      const divWrap = document.createElement("div");
      divWrap.classList.add("col-sm-6", "h-auto", "d-flex");
      button.classList.add(
        "btn",
        "btn-secondary",
        "mb-md-4",
        "mb-3",
        "d-flex",
        "align-items-center",
        "w-100",
        "justify-content-center"
      );
      button.parentNode.insertBefore(divWrap, button);
      return divWrap.appendChild(button);
    });
    [...brElements].forEach((br) => {
      br.remove();
    });
  };

  //Table making elements
  const makeThFunction = (thInner, tr) => {
    //const arrayPush = [];
    [...thInner].forEach((th) => {
      let thElement = document.createElement("th");
      let thText = document.createTextNode(th.textContent);
      let FinalTh = thElement.appendChild(thText);
      return tr.append(thElement);
    });
    return;
  };

  const makeTableFunction = () => {
    const tables = document.querySelectorAll(".paste-table table");
    [...tables].forEach((table) => {
      table.classList.add("tablesorter");
      const tbody = document.querySelector("tbody");
      const row = table.querySelectorAll("tr");
      const tableHead = row[0];
      const thInner = tableHead.querySelectorAll("td");
      let tr = document.createElement("tr");
      if (table.querySelectorAll("th").length == 0) {
        makeThFunction(thInner, tr);
        let thead = document.createElement("thead");
        thead.append(tr);
        table.prepend(thead);
        row[0].remove();
      }
    });
  };
  makeLinksIntoButtons();
  makeTableFunction();
  AOS.init();
});

// mobile Menus

const navIcons = document.getElementById("nav-icon1");
const navMenu = document.querySelector(".burger-menu");

const burgerMenu = () => {
  const mobMenu = document.querySelector(".mobile-menu");
  document.querySelectorAll(".burger").forEach(function (icon) {
    icon.classList.toggle("open");
  });
  mobMenu.classList.toggle("open");
};

navIcons.addEventListener("click", function () {
  burgerMenu();
});
navMenu.addEventListener("click", function () {
  burgerMenu();
});
